exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flip-list-move {\n    transition: transform 0.5s;\n}\n.no-move {\n    transition: transform 0s;\n}\n.ghost {\n    opacity: 0.5;\n    background: #c8ebfb;\n}\n\n", ""]);

// exports
